<div class="home">
  <app-banner [activeServicesCount]="activeServicesCount" [environmentsCount]="environmentsCount"></app-banner>
  <app-service-definition-cards [blueprintCards]="blueprintCards" [loader]="isLoading"></app-service-definition-cards>
</div>
